import { Injectable } from '@angular/core';
import { interval } from 'rxjs/internal/observable/interval';
import { Subscription } from 'rxjs/internal/Subscription';

@Injectable({
	providedIn: 'root',
})
export class PolTimerManagerService {
	public totalTime: number = 0;
	public manualTime: number = 0;
	public warningTime: number = 0;
	public noFaceTime: number = 0;
	public KOHelpTime: number = 0;
	public middleFaceAwayTime: number = 0;
	public offCenterTime: number = 0;

	private subsTotalTime: Subscription;
	private subsManualTime: Subscription;
	private subsWarningTime: Subscription;
	private subsNoFaceTime: Subscription;
	private subsKOHelpTime: Subscription;
	private subsMiddleFaceAwayTime: Subscription;
	private subsOffCenterTime: Subscription;

	// Total Time
	public startTotalTime(): void {
		if (!this.subsTotalTime) {
			this.subsTotalTime = this.createTimer(() => this.totalTime++);
		}
	}
	public stopTotalTime(): void {
		if (this.subsTotalTime) {
			this.subsTotalTime.unsubscribe();
			this.subsTotalTime = null;
		}
	}
	public resetTotalTime(): void {
		this.totalTime = 0;
	}

	// Manual Time
	public startManualTime(fn: () => void): void {
		if (!this.subsManualTime) {
			this.subsManualTime = this.createTimer(() => {
				this.manualTime++;
				fn();
			});
		}
	}
	public stopManualTime(): void {
		if (this.subsManualTime) {
			this.subsManualTime.unsubscribe();
			this.subsManualTime = null;
		}
		this.manualTime = 0;
	}

	// Warning Time
	public startWarningTime(fn: () => void): void {
		if (!this.subsWarningTime) {
			this.subsWarningTime = this.createTimer(() => {
				this.warningTime++;
				fn();
			});
		}
	}
	public stopWarningTime(): void {
		if (this.subsWarningTime) {
			this.subsWarningTime.unsubscribe();
			this.subsWarningTime = null;
		}
		this.warningTime = 0;
	}

	// No Face Time
	public startNoFaceTime(fn: () => void): void {
		if (!this.subsNoFaceTime) {
			this.subsNoFaceTime = this.createTimer(() => {
				this.noFaceTime++;
				fn();
			});
		}
	}
	public stopNoFaceTime(): void {
		if (this.subsNoFaceTime) {
			this.subsNoFaceTime.unsubscribe();
			this.subsNoFaceTime = null;
		}
		this.noFaceTime = 0;
	}

	// KO Help Time
	public startKOHelpTime(fn: () => void): void {
		if (!this.subsKOHelpTime) {
			this.subsKOHelpTime = this.createTimer(() => {
				this.KOHelpTime++;
				fn();
			});
		}
	}
	public stopKOHelpTime(): void {
		if (this.subsKOHelpTime) {
			this.subsKOHelpTime.unsubscribe();
			this.subsKOHelpTime = null;
		}
		this.KOHelpTime = 0;
	}

	// Middle Face Away Time
	public startMiddleFaceAwayTime(fn: () => void): void {
		if (!this.subsMiddleFaceAwayTime) {
			this.subsMiddleFaceAwayTime = this.createTimer(() => {
				this.middleFaceAwayTime++;
				fn();
			});
		}
	}
	public stopMiddleFaceAwayTime(): void {
		if (this.subsMiddleFaceAwayTime) {
			this.subsMiddleFaceAwayTime.unsubscribe();
			this.subsMiddleFaceAwayTime = null;
		}
		this.middleFaceAwayTime = 0;
	}

	// Off Center Time
	public startOffCenterTime(fn: () => void): void {
		if (!this.subsOffCenterTime) {
			this.subsOffCenterTime = this.createTimer(() => {
				this.offCenterTime++;
				fn();
			});
		}
	}
	public stopOffCenterTime(fn: () => void): void {
		if (this.subsOffCenterTime) {
			this.subsOffCenterTime.unsubscribe();
			this.subsOffCenterTime = null;
		}
		this.offCenterTime = 0;
		fn();
	}

	public stopAllTimers(): void {
		this.stopWarningTime();
		this.stopNoFaceTime();
		this.stopKOHelpTime();
	}

	// Utilidad para crear timer
	private createTimer(callback: () => void): Subscription {
		// Usar timer de RxJS para incrementar cada segundo
		return interval(1000).subscribe(callback);
	}
}
